import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ParticulierRoutingModule } from "./particulier-routing.module";
import { SharedModule } from "../shared/shared.module";
import { DossierHistoriqueComponent } from "./dossier-historique/dossier-historique.component";
import { EnCorrectionComponent } from "./dossier-historique/en-correction/en-correction.component";
import { ClotureComponent } from "./dossier-historique/cloture/cloture.component";
import { AbandonneComponent } from "./dossier-historique/abandonne/abandonne.component";
import { EnCoursComponent } from "./dossier-historique/en-cours/en-cours.component";
import { DossierInfoComponent } from "./dossier-info/dossier-info.component";
import { DossierInfoDetailTabComponent } from "./dossier-info/tab/dossier-info-detail-tab/dossier-info-detail-tab.component";
import { DossierUpdateComponent } from "./dossier-update/dossier-update.component";
import { UpdateDossierInfoComponent } from "./dossier-update/form/update-dossier-info/update-dossier-info.component";
import { CreateDossierCreditComponent } from "./formulaire/createform/create-dossier-credit/create-dossier-credit.component";
import { FormulaireLayoutComponent } from "./formulaire/formulaire-layout/formulaire-layout.component";
import { BniCreateDossierCreditComponent } from "./formulaire/createform/bni-create-dossier-credit/bni-create-dossier-credit.component";
import { FormulaireModule } from "../formulaire/formulaire.module";
import { FormScanPieceComponent } from "./formulaire/taskform/form-scan-piece/form-scan-piece.component";
import { FormMiseEnPlaceCreditComponent } from "./formulaire/taskform/form-mise-en-place-credit/form-mise-en-place-credit.component";
import { GarantieListComponent } from "./dossier-info/tab/garantie-list/garantie-list.component";
import { ItemDetailComponent } from "./dossier-info/tab/garantie-list/item-detail/item-detail.component";
import { AddGarantieDetailComponent } from "./dossier-info/tab/garantie-list/add-garantie-detail/add-garantie-detail.component";
import { EditCreditModalComponent } from "./formulaire/modal/edit-credit-modal/edit-credit-modal.component";
import { DossierHistoriqueNewComponent } from "./dossier-historique-new/dossier-historique-new.component";
import { ReportingModule } from "../reporting/reporting.module";
import { AddDocumentGarantieComponent } from "./dossier-info/tab/garantie-list/add-document-garantie/add-document-garantie.component";
import { EditGarantieDetailComponent } from "./dossier-info/tab/garantie-list/edit-garantie-detail/edit-garantie-detail.component";
import { AddGarantieToDossierComponent } from './formulaire/createform/add-garantie-to-dossier/add-garantie-to-dossier.component';
import { FormAddConditionComponent } from './formulaire/modal/form-add-condition/form-add-condition.component';
import { FormEditConditionComponent } from './formulaire/modal/form-edit-condition/form-edit-condition.component';
import { TousComponent } from './dossier-historique/tous/tous.component';
import { DossierHistoriqueAllComponent } from './dossier-historique-all/dossier-historique-all.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

@NgModule({
  imports: [
    NgMultiSelectDropDownModule.forRoot(),
    CommonModule,
    ParticulierRoutingModule,
    SharedModule,
    FormulaireModule,
    ReportingModule,
    NgxDaterangepickerMd.forRoot()
  ],

  declarations: [
    DossierHistoriqueComponent,
    EnCorrectionComponent,
    ClotureComponent,
    AbandonneComponent,
    EnCoursComponent,
    DossierInfoComponent,
    DossierInfoDetailTabComponent,
    DossierUpdateComponent,
    UpdateDossierInfoComponent,
    CreateDossierCreditComponent,
    FormulaireLayoutComponent,
    BniCreateDossierCreditComponent,
    FormScanPieceComponent,
    FormMiseEnPlaceCreditComponent,

    ItemDetailComponent,
    GarantieListComponent,
    AddDocumentGarantieComponent,
    EditGarantieDetailComponent,
    AddGarantieDetailComponent,
    
    EditCreditModalComponent,
    DossierHistoriqueNewComponent,

    AddGarantieToDossierComponent,
    FormAddConditionComponent,
    FormEditConditionComponent,
    TousComponent,
    DossierHistoriqueAllComponent
  ],

  entryComponents: [
    ItemDetailComponent,
    AddGarantieDetailComponent,
    AddDocumentGarantieComponent,
    EditGarantieDetailComponent,
    EditCreditModalComponent,
    FormAddConditionComponent,
    FormEditConditionComponent
  ],

  providers: [],
})
export class ParticulierModule {}
